module.exports = __webpack_public_path__ + "06_bob_black.4939790b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/06_bob_black.png
// module id = a/cE
// module chunks = 0